import { MouseEventHandler } from "react";
import NotesIcon from "@/components/Icons/notes";
import TextWithIcon from "@/components/TextWithIcon";

interface Props {
  onIconClick: MouseEventHandler<HTMLButtonElement>;
}

const LatestNote = ({ onIconClick }: Props) => {
  const tooltipCopy = "Click to view note history.";

  return (
    <TextWithIcon
      id="add-note-icon"
      icon={NotesIcon}
      iconTooltip="Open note history"
      text="View Notes"
      textTooltip={tooltipCopy}
      onIconClick={onIconClick}
    />
  );
};

export default LatestNote;
